import React, { useEffect, useState, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { generateOtp, generateMobOtp, verifyOtp, verifymobOtp } from "../configs/WebService";
import { type } from "@testing-library/user-event/dist/cjs/utility/type.js";
import { setAppdAiGuest } from "../utils/appdAiHelpers";
import { handleUserData, setAuthData } from "../auth/authSlice";
import userStore from "../zustand/userStore";
import { useDispatch } from "react-redux";
import {
  sendWelcomeEmail,
  sendWelcomeSMS,
  sendWelcomeTemplate,
} from "../features/student/redux/studentThunk";
import AudioToggleButton from "../components/AudioToggleButton";
import RegistrationStepper from "../components/RegistrationStepper";
import { fireRegistrationWebhook } from "../utils/webhook";
import { trackMetaPixelRegistration } from "../utils/metaPixel";
import { showToast } from "../components/ClassicToast";
// Replace this with your actual API endpoint
const WSVerifyOTP = "https://your-domain.com/api/verify-otp";

const OtpVerification = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const hasInitialized = useRef(false);
  const audioRef = useRef(null);

  const [otp, setOtp] = useState("");
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState("");
  const [mobile, setMobile] = useState("");
  const [step, setStep] = useState("email"); // "email" or "mobile"
  const [userPayload, setUserPayload] = useState(null); // Full payload from signup
  const [resendTimer, setResendTimer] = useState(59);
  const [canResend, setCanResend] = useState(false);

  useEffect(() => {
    if (canResend) return;
    if (resendTimer === 0) { setCanResend(true); return; }
    const t = setTimeout(() => setResendTimer((prev) => prev - 1), 1000);
    return () => clearTimeout(t);
  }, [resendTimer, canResend]);

  useEffect(() => {
    setResendTimer(59);
    setCanResend(false);
  }, [step]);
  const payload = location.state?.formData;
  const source = location.state?.source;
  const isWhatsapp = location.state?.isWhatsapp;
  const isEmailSuccessful = location.state?.isEmailSuccessful;
  const isSMS = location.state?.isSMS;
  const accountType = location.state?.account_type || location.state?.notificationPayload?.account_type;
  const signupPayload = location.state?.notificationPayload || location.state?.formData;
  const role = location.state?.role;
  const phone = payload?.contactNumber || payload?.contact_number;
  const setUser = userStore.getState().setUser;
  const activeStepIndex = 1;

  // console.log("signupPayload", signupPayload)

  const otpAudioTimers = useRef([]);

  const stopAudio = () => {
    otpAudioTimers.current.forEach((t) => clearTimeout(t));
    otpAudioTimers.current = [];
    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current.currentTime = 0;
    }
  };

  // useEffect(() => {
  //   setAppdAiGuest("registration");
  // }, []);

  // Auto-play otp audio: play 0-14, pause 10s, then play 14-end
  // useEffect(() => {
  //   const audio = new Audio("/audio/Registration page/Script 4a — mdm_otp_sent_v1.mp3");
  //   audioRef.current = audio;
  //   audio.play().catch(() => {});

  //   // Pause at 14 seconds
  //   const pauseTimer = setTimeout(() => {
  //     if (!audio.paused && !audio.ended) {
  //       audio.pause();
  //     }
  //   }, 14000);
  //   otpAudioTimers.current.push(pauseTimer);

  //   // Resume from 14s after 10s delay (at 24s total)
  //   const resumeTimer = setTimeout(() => {
  //     if (audioRef.current === audio) {
  //       audio.currentTime = 14;
  //       audio.play().catch(() => {});
  //     }
  //   }, 24000);
  //   otpAudioTimers.current.push(resumeTimer);

  //   return () => {
  //     otpAudioTimers.current.forEach((t) => clearTimeout(t));
  //     otpAudioTimers.current = [];
  //     audio.pause();
  //     audio.currentTime = 0;
  //     audioRef.current = null;
  //   };
  // }, []);

  useEffect(() => {
    // 2. Only run the logic if it hasn't run before and state exists
    if (hasInitialized.current || !location.state) return;
    if (role === "guest_user" && phone) {
      setStep("mobile");
      setMobile(phone);
      setUserPayload(payload);
      sendOtpToMobile(phone);
      hasInitialized.current = true;
      return;
    }
    if (source === "login") {
      if (payload?.email && !phone) {
        setEmail(payload.email);
        setMobile("");
        setUserPayload(payload);
        sendOtpToEmail(payload.email);
        hasInitialized.current = true; // Mark as done
      } else if (phone && !payload?.email) {
        setStep("mobile");
        setMobile(phone);
        setUserPayload(payload);
        sendOtpToMobile(phone);
        hasInitialized.current = true; // Mark as done
      } else if (payload?.email && phone) {
        setEmail(payload.email);
        setMobile(phone);
        setUserPayload(payload);
        sendOtpToEmail(payload.email);
        hasInitialized.current = true; // Mark as done
      }
    } else {
      // Signup Logic
      if (payload?.email && phone) {
        setEmail(payload.email);
        setMobile(phone);
        setUserPayload(payload);
        sendOtpToEmail(payload.email);
        hasInitialized.current = true; // Mark as done
      } else {
        // alert("No user data found. Redirecting...");
        showToast("error", "No user data found. Redirecting...");
        stopAudio();
        navigate("/registration");
      }
    }
  }, [location, navigate]);

  const sendOtpToMobile = async (mobileNumber) => {
    try {
      const response = await fetch(generateMobOtp, { // Using your mobile config
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ otpType: "mobile", otpSentTo: mobileNumber }), // Ensure your backend expects 'to'
      });

      if (response.ok) {
        console.log("OTP sent successfully to mobile:", mobileNumber);
        // document.dispatchEvent(new CustomEvent('mdm:otp', { detail: { status: 'sent' } }));
        // alert("Now, an OTP has been sent to your mobile.");
        showToast("success", "Now, an OTP has been sent to your mobile.");
      } else {
        // alert("Email verified, but failed to send Mobile OTP. Please use Resend.");
        showToast("error", "Email verified, but failed to send Mobile OTP. Please use Resend.");
      }
    } catch (error) {
      console.error("Mobile OTP error:", error);
    }
  };

  const sendOtpToEmail = async (email) => {
    try {
      const response = await fetch(generateOtp, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ to: email, otpType: "email_verify" }),
      });

      const data = await response.json();

      if (response.ok) {
        console.log("OTP sent successfully to:", email);
        // document.dispatchEvent(new CustomEvent('mdm:otp', { detail: { status: 'sent' } }));
      } else {
        console.error("OTP send error:", data?.error || "Unknown error");
        // alert("Failed to send OTP: " + (data?.error || "Please try again."));
        showToast("error", "Failed to send OTP: " + (data?.error || "Please try again."));
      }
    } catch (error) {
      console.error("Network error while sending OTP:", error);
      // alert("Network error. Please try again later.");
      showToast("error", "Network error. Please try again later.");
    }
  };


  // const handleVerifyOtp = async (e) => {
  //   e.preventDefault();

  //   if (!otp) {
  //     alert("Please enter the OTP.");
  //     return;
  //   }

  //   setLoading(true);

  //   try {
  //     const response = await fetch(verifyOtp, {
  //       method: "POST",
  //       headers: { "Content-Type": "application/json" },
  //       body: JSON.stringify({
  //         to: step==="email" ? email:mobile,
  //         otp:otp,
  //       }),
  //     });

  //     const data = await response.json();

  //     if (response.ok) {
  //       alert(`✅ ${step === "email" ? "Email" : "Mobile"} OTP Verified Successfully!`);
  //       setOtp(""); // clear input

  //       if (step === "email") {
  //         //navigate("/login");
  //         setStep("mobile"); //uncomment for mobile otp
  //         sendOtpToMobile(mobile);
  //       }else{
  //         navigate("/login");
  //       }

  //     } else {
  //       alert("❌ Invalid OTP: " + (data?.error || "Please try again."));
  //     }
  //   } catch (error) {
  //     console.error("OTP verification error:", error);
  //     alert("Network error during OTP verification.");
  //   } finally {
  //     setLoading(false);
  //   }
  // };
  const handleVerifyOtp = async (e) => {
    e.preventDefault();

    if (!otp) {
      // alert("Please enter the OTP.");
      showToast("error", "Please enter the OTP.");
      return;
    }

    setLoading(true);

    // 1. Determine which API and Payload to use based on the current step
    const apiUrl = step === "email" ? verifyOtp : verifymobOtp; // Update with your actual full mobile verify URL

    const payload = step === "email"
      ? { to: email, otp: otp, otpType: "email_verify" }
      : { to: mobile, otp: otp }; // Mobile usually expects 'otpSentTo' based on your previous thunk

    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const data = await response.json();
      console.log("data_182", data)

      if (response.ok) {
        if (step === "email") {
          // --- EMAIL SUCCESS ---
          // document.dispatchEvent(new CustomEvent('mdm:otp', { detail: { status: 'verified' } }));
          // alert("✅ Email Verified!");
          showToast("success", "Email Verified!");
          setOtp("");
          if (phone) {
            setStep("mobile"); // This updates your UI text automatically               
            await sendOtpToMobile(mobile);
          } else {
            stopAudio();
            navigate("/login");
          }
        } else {
          // --- MOBILE SUCCESS ---
          // document.dispatchEvent(new CustomEvent('mdm:otp', { detail: { status: 'verified' } }));

          // Send notifications after mobile verification
          const notifications = [];
          if (isWhatsapp === 1) {
            notifications.push(dispatch(sendWelcomeTemplate(signupPayload)).unwrap());
          }
          if (isEmailSuccessful === 1) {
            notifications.push(dispatch(sendWelcomeEmail(signupPayload)).unwrap());
          }
          if (isSMS === 1) {
            notifications.push(dispatch(sendWelcomeSMS(signupPayload)).unwrap());
          }
          if (notifications.length > 0) {
            try {
              await Promise.all(notifications);
            } catch (notifyError) {
              console.error("Notification sending error:", notifyError);
            }
          }

          // alert("✅ Mobile verified successfully! Your registration process is completed.");
          showToast("success", "Mobile verified successfully! Your registration process is completed.");
          trackMetaPixelRegistration();
          // fireRegistrationWebhook({
          //   phone_number: signupPayload?.contactNumber || signupPayload?.contact_number,
          //   email: signupPayload?.email,
          //   user_type: accountType || "",
          //   event_type: "otp_verified",
          // });
          dispatch(setAuthData(data));
          setUser(data.user);
          // navigate("/login");
          stopAudio();
          // navigate("/paywall");
          navigate("/pricing");
        }
      } else {
        // alert("❌ Verification Failed: " + (data?.message || data?.error || "Invalid OTP"));
        showToast("error", "Verification Failed: " + (data?.message || data?.error || "Invalid OTP"));
      }
    } catch (error) {
      console.error("Verification Error:", error);
      // alert("Network error. Please try again.");
      showToast("error", "Network error. Please try again.");
    } finally {
      setLoading(false);
    }
  };
  const handleResendOtp = async () => {
    setLoading(true);

    try {
      // 1. Determine which URL to hit
      const targetApi = step === "email" ? generateOtp : generateMobOtp;

      // 2. Prepare the correct payload for each step
      const payload = step === "email"
        ? { to: email, otpType: "email_verify" }
        : { otpType: "mobile", otpSentTo: mobile };

      const response = await fetch(targetApi, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const data = await response.json();

      if (response.ok) {
        // document.dispatchEvent(new CustomEvent('mdm:otp', { detail: { status: 'sent' } }));
        // alert(`OTP resent successfully to your ${step === "email" ? "Email" : "Mobile"}.`);
        showToast("success", `OTP resent successfully to your ${step === "email" ? "Email" : "Mobile"}.`);
        setResendTimer(59);
        setCanResend(false);
      } else {
        // alert("Failed to resend OTP: " + (data.error || "Please try again later."));
        showToast("error", "Failed to resend OTP: " + (data.error || "Please try again later."));
      }
    } catch (error) {
      console.error("Resend OTP error:", error);
      // alert("Network error during OTP resend.");
      showToast("error", "Network error during OTP resend.");
    } finally {
      setLoading(false);
    }
  };

  const handleCancelVerification = () => {
    const confirmCancel = window.confirm("Are you sure you want to quit verification?");
    if (confirmCancel) {
      stopAudio();
      navigate(role === "guest_user" ? "/registration" : "/signup");
    }
  };

  return (
    <>
      <AudioToggleButton audioRef={audioRef} />
      <style>{`
      /* Otp card */
#root .otp-card{
 transform:translatex(6px) translatey(85px);
}

        .otp-page-container {
          min-height: 100vh;
          display: flex;
          align-items: stretch;
          justify-content: flex-start;
          background: linear-gradient(135deg, #4a7fc5 0%, #3a9ea8 50%, #38b89c 100%);
        }

        .otp-layout {
          width: 100%;
          display: flex;
          align-items: stretch;
          justify-content:center;
          margin: 40px 0;
          gap: 28px;
        }

        .otp-sidebar {
          width: 250px;
          min-width: 250px;
          flex-shrink: 0;
          display: flex;
        }

        .otp-card {
          width: 100%;
          max-width: 430px;
          padding: 32px 28px;
          border-radius: 28px;
          background: #ffffff;
          box-shadow: 0 25px 80px rgba(15, 23, 42, 0.18);
          height: fit-content;
          
          
        }

        .otp-close-row {
          display: flex;
          justify-content: flex-end;
          margin-bottom: 6px;
        }

        .otp-title {
          margin: 0 0 10px;
          text-align: center;
          font-size: 28px;
          font-weight: 800;
          color: #1e293b;
        }

        .otp-subtitle {
          margin: 0 0 22px;
          text-align: center;
          color: #64748b;
          line-height: 1.6;
          font-weight: 600;
        }

        .otp-input {
          width: 100%;
          padding: 14px 16px;
          border: 2px solid #e2e8f0;
          border-radius: 14px;
          outline: none;
          font-size: 15px;
          font-weight: 600;
          color: #1e293b;
          transition: border-color 0.2s ease, box-shadow 0.2s ease;
        }

        .otp-input:focus {
          border-color: #667eea;
          box-shadow: 0 0 0 4px rgba(102, 126, 234, 0.14);
        }

        .otp-submit {
          width: 100%;
          margin-top: 16px;
          border: 0;
          border-radius: 14px;
          padding: 14px 16px;
          background: linear-gradient(135deg, #16a34a, #22c55e);
          color: #ffffff;
          font-size: 15px;
          font-weight: 800;
          cursor: pointer;
          transition: transform 0.2s ease, box-shadow 0.2s ease;
          box-shadow: 0 16px 30px rgba(34, 197, 94, 0.25);
        }

        .otp-submit:disabled {
          cursor: not-allowed;
          opacity: 0.7;
          transform: none;
          box-shadow: none;
        }

        .otp-resend {
          width: 100%;
          margin-top: 16px;
          background: transparent;
          border: 0;
          color: #5b67f1;
          font-weight: 700;
          cursor: pointer;
        }

        .otp-resend:disabled {
          opacity: 0.7;
          cursor: not-allowed;
        }
@media (max-width: 768px) {
  .otp-page-container {
    flex-direction: column;
  }
        @media (max-width: 900px) {
          .otp-page-container {
            padding: 20px 14px;
          }

          .otp-layout {
            flex-direction: column;
            align-items: stretch;
          }

          .otp-sidebar,
          .otp-card {
            width: 100%;
            max-width: 100%;
          }
        }
          /* Otp card */
#root .otp-card{
 transform:translatex(0px) translatey(119px) !important;
}


      `}</style>

      <div className="otp-page-container">
      
          <div className="otp-sidebar">
            <RegistrationStepper activeStep={activeStepIndex} />
          </div>
  <div className="otp-layout">
          <div className="otp-card">
            <div className="otp-close-row">
              <button
                type="button"
                className="btn-close"
                aria-label="Close"
                onClick={handleCancelVerification}
                style={{ fontSize: "0.5rem" }}
              ></button>
            </div>

            <p className="otp-title">Verify {step === "email" ? "Email" : "Mobile"}</p>
            <p className="otp-subtitle">
              Enter the OTP sent to <strong>{step === "email" ? email : mobile}</strong>
            </p>

            <form onSubmit={handleVerifyOtp}>
              <input
                type="text"
                className="otp-input"
                placeholder="Enter OTP"
                value={otp}
                onChange={(e) => setOtp(e.target.value)}
                maxLength={10}
              />

              <button type="submit" className="otp-submit" disabled={loading}>
                {loading ? "Verifying..." : "Verify OTP"}
              </button>
            </form>

            <button className="otp-resend" onClick={handleResendOtp} disabled={!canResend || loading}>
              {canResend ? "Resend OTP" : `Resend OTP (00:${String(resendTimer).padStart(2, "0")})`}
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default OtpVerification;
